export default "__VITE_ASSET__f6cd3ead__"